/**
 * Layout component 
 */
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { AuthProvider, useAuth } from "../../context/authContext"
import Chatbot from "../chatbot"
import Footer2021 from "../footer2021"
import Header2021 from "../header2021"
import LoginModal from "../modals/loginModal"
import SEO2021 from "../seo2021"
import "./layout.css"
import styles from "./layout.module.css"

const Layout = ({ children, disableHeader }) => {
  const [chatbotOpen, setChatbotOpen] = useState(false)
  const { getUser, user: authUser } = useAuth()
  const [user, setUser] = useState(authUser)
  const [modalState, setModalState] = useState(false)
  const [status, setStatus] = useState("ready")

  const handleOnChatbotClick = () => {
    setChatbotOpen(!chatbotOpen)
  }

  const handleOnLoginModalSuccess = () => {
    setModalState(true)
    setUser({}) // temp user object
  }

  const handleOnRegistrationClick = event => {
    event.preventDefault()
    setModalState(!modalState)
    if (status == "success" && modalState == false) {
      setStatus("ready")
    }
  }

  const checkUserState = () => {
    getUser()
      .then(user => {
        if (user) {
          const {
            username,
            attributes: { sub: id },
          } = user
          setUser({ username, id })
          // setModalState(!user)
        } else {
          setUser(null)
        }
      })
      .catch(error => {
        console.log("error", error)
      })
  }

  useEffect(() => {
    checkUserState()
  }, [])


  useEffect(() => {
    const html = document.documentElement
    chatbotOpen ? html.style.overflow = "hidden" : html.style.overflow = ""
  
    return () => {
      html.style.overflow = ""
    }
  }, [chatbotOpen])
  
  return (
    <>
    <AuthProvider value={{ user, getUser, handleOnRegistrationClick }}>
      <SEO2021 title="AI Week 2025" />
      <Header2021 disableHeader={disableHeader} onRegisterClick={handleOnRegistrationClick} onChatbotClick={handleOnChatbotClick} />
      <Chatbot 
        open={chatbotOpen} 
        onOpen={() => setChatbotOpen(true)}
        onClose={() => setChatbotOpen(false)} 
      />
      <div className={`container ${styles.container}`}>
        <main>{children}</main>
        {/*<Footer2021 />*/}
      </div>
      <LoginModal
        onRegisterClick={handleOnRegistrationClick}
        open={modalState}
        onFailure={null}
        onSuccess={handleOnLoginModalSuccess}
        onClose={() => setModalState(false)}
        status={status}
        setStatus={setStatus}
      />
    </AuthProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
